import { render } from "./warning.vue?vue&type=template&id=3b9522c4&scoped=true"
import script from "./warning.vue?vue&type=script&lang=js"
export * from "./warning.vue?vue&type=script&lang=js"

import "./warning.vue?vue&type=style&index=0&id=3b9522c4&scoped=true&lang=css"
import "@/styles/common.css?vue&type=style&index=1&id=3b9522c4&scoped=true&lang=css"
import "@/styles/subcommon.css?vue&type=style&index=2&id=3b9522c4&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/tcd-partnerpage-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b9522c4"]])

export default __exports__